import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { IChecklistInitialState } from "./types";
import initialState from "./state";

interface SetJoystickStatusPayload {
  serialNumber: string;
  connected: boolean;
  joystickId?: string | null;
}

interface SetCameraStatusPayload {
  serialNumber: string;
  connected: boolean;
}

const setJoystickStatus: CaseReducer<IChecklistInitialState, PayloadAction<SetJoystickStatusPayload>> = (state, action) => {
  const { serialNumber, connected, joystickId } = action.payload;
  
  if (!state.equipmentStatus[serialNumber]) {
    state.equipmentStatus[serialNumber] = {
      joystickConnected: false,
      joystickId: null,
      cameraConnected: false,
    };
  }
  
  state.equipmentStatus[serialNumber].joystickConnected = connected;
  if (joystickId !== undefined) {
    state.equipmentStatus[serialNumber].joystickId = joystickId;
  }
};

const setCameraStatus: CaseReducer<IChecklistInitialState, PayloadAction<SetCameraStatusPayload>> = (state, action) => {
  const { serialNumber, connected } = action.payload;
  
  if (!state.equipmentStatus[serialNumber]) {
    state.equipmentStatus[serialNumber] = {
      joystickConnected: false,
      joystickId: null,
      cameraConnected: false,
    };
  }
  
  state.equipmentStatus[serialNumber].cameraConnected = connected;
};

const resetEquipmentStatus: CaseReducer<IChecklistInitialState, PayloadAction<string>> = (state, action) => {
  const serialNumber = action.payload;
  delete state.equipmentStatus[serialNumber];
};

export default { setJoystickStatus, setCameraStatus, resetEquipmentStatus };

